module.exports = __webpack_public_path__ + "static/drata-soc2-light-7134ba7f6162d6d369738cfb5a34aa9b.png";